import React, { useContext, useEffect, useState, useTransition } from "react";
import "./CadastroAgendamento.scss";
import { useForm } from "react-hook-form";
import GlobalContext from "@context/GlobalContext";
import DropDownList from "@components/dropDownList/DropDownList";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import Button from "@components/button/Button";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import EndPointServices from "@services/ApiServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import CheckBox from "@components/checkbox/CheckBox";
import MessageServices from "@services/MessageServices";
import useLoading from "@hooks/useLoading";

const CadastroAgendamento = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();
  const [isPendingD, startTransitionD] = useTransition();

  useLoading(isPending);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm();

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);

  //Empresas
  const [ids_empresa, setIdsEmpresa] = useState([]);
  const [dadosEmpresa, setDadosEmpresas] = useState([]);
  const [dadosEmpresaBKP, setDadosEmpresasBKP] = useState([]);
  const [dadosLstEmpresa, setDadosLstEmpresa] = useState([]);

  //Manual
  const [check, setCheck] = useState(false);

  //Retroativos.
  const [dadosMassivoRetro, setDadosMassivoRetro] = useState([]);

  useEffect(() => {
    handleCamposDefault();
    handleConsultaLstEmpresa();
  }, []);

  /*Funções do DropDownLst.*/
  function handleCamposDefault() {
    handleChangeDropDownLst("qualautomacao", "EFD Contribuição", {
      id: 1,
      key: "EFD Contribuição",
    });
    handleChangeDropDownLst("pulardominio", "Não", {
      id: 1,
      key: "Não",
    });
    handleChangeDropDownLst("spedretificadora", "Não", {
      id: 0,
      key: "Não",
    });
  }
  const [valueDropDownLst, setValueDropDownLst] = useState([]);
  function handleChangeDropDownLst(name, value, valueAdicionar) {
    setValue(name, value);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));

    if (name === "spedretificadora") {
      setDadosMassivoRetro([]);
    }
  }
  function handleConsultaEmpresa() {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        // mesano: valueDropDownLst["competencia"]?.key
        //   .split("/")
        //   .reverse()
        //   .join("\\"),
        id_empresa: valueDropDownLst["empresa"]?.id,
        id_compartilhado: 1,
      };

      var retornoapi =
        await EndPointServices.Rpa_ConsultaAgendadorEmpresaCadastro(data);

      if (retornoapi?.Success) {
        setDadosEmpresas(retornoapi?.BaseReturn?.LstClasse);
        setDadosEmpresasBKP(retornoapi?.BaseReturn?.LstClasse);
      }
    });
  }
  function handleConsultaLstEmpresa() {
    startTransitionD(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_compartilhado: 1,
      };

      var retornoapi =
        await EndPointServices.Rpa_ConsultaAgendadorEmpresaCadastro(data);

      if (retornoapi?.Success) {
        let lst = retornoapi?.BaseReturn?.LstClasse?.reduce((acc, item) => {
          const obj = {
            id: item["id_empresa"],
            key: item["Razão Social"],
          };

          // verifica se já existe no acumulador pelo id
          if (!acc.some((x) => x.id === obj.id)) {
            acc.push(obj);
          }

          return acc;
        }, []);

        setDadosLstEmpresa(lst);
      }
    });
  }

  useEffect(() => {
    handleConsultaEmpresa();
  }, []);

  useEffect(() => {
    handleConsultaEmpresa();
  }, [valueDropDownLst["empresa"]?.key]);

  function handleSalvarAgendamento(e) {
    if (ids_empresa.length === 0) {
      MessageServices.ShowWarning(
        "É obrigatório selecionar ao menos uma empresa no grid.",
      );
      return;
    }
    if (
      dadosMassivoRetro.length === 0 &&
      valueDropDownLst["spedretificadora"].id === 1
    ) {
      MessageServices.ShowWarning(
        "Para retroativos é necessário calcular os meses e incluir os recibos.",
      );
      return;
    }

    startTransition(async () => {
      let dados = {
        hora: e?.hora,
        data: e?.data,
        qualautomacao: valueDropDownLst["qualautomacao"]?.id,
        tipoagendamento:
          e?.tipoagendamento === "Manual (Somente desta vez)"
            ? "Manual"
            : e?.tipoagendamento,
        tipomensal: e?.tipomensal,
        checkmanualproximosmeses: check,
        mesinicial: e?.mesinicial,
        mesfinal: e?.mesfinal,
        pulardominio: valueDropDownLst["pulardominio"]?.id === 1 ? true : false,
        ids_empresa: ids_empresa.map((item) => ({
          id_empresa: item.id_empresa,
        })),
        mesano: e.competencia.split("/").reverse().join("\\"),
        retroativo: {
          ...dadosMassivoRetro.map((item) => ({
            ...item,
            competencia: item.competencia.split("/").reverse().join("\\"),
            id_recibo: e[`idrecibo_${item?.id_empresa}_${item?.competencia}`],
          })),
        },
      };

      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };

      var retornoapi = await EndPointServices.Rpa_AdicionarAgendador(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Agendamento foi com sucesso!");
        handleClear();
      }
    });
  }
  function handleClear() {
    startTransitionB(async () => {
      setDadosEmpresas(dadosEmpresaBKP);
    });
    reset();
    setValueDropDownLst([]);
    handleCamposDefault();
    setIdsEmpresa([]);
    setDadosMassivoRetro([]);
  }
  function handleGenerateCompetencias() {
    setDadosMassivoRetro([]);

    const [startMonth, startYear] = watch("decompetencia")
      .split("/")
      .map(Number);
    const [endMonth, endYear] = watch("atecompetencia").split("/").map(Number);

    // cria objeto Date no primeiro dia do mês
    const dateStart = new Date(startYear, startMonth - 1, 1);
    const dateEnd = new Date(endYear, endMonth - 1, 1);

    if (ids_empresa.length === 0) {
      MessageServices.ShowWarning(
        "É obrigatório selecionar ao menos uma empresa no grid.",
      );
      return;
    }

    if (ids_empresa.length > 1) {
      MessageServices.ShowWarning(
        "É possível realizar o retroativo de apenas uma empresa por vez.",
      );
      return;
    }

    if (
      dateStart >=
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
    ) {
      MessageServices.ShowWarning(
        "A data inicial da competência não pode ser maior ou igual à competência do mês anterior ao corrente.",
      );
      return;
    }

    if (
      dateEnd >=
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
    ) {
      MessageServices.ShowWarning(
        "A data final da competência não pode ser maior ou igual à competência do mês anterior ao corrente.",
      );
      return;
    }

    if (dateStart > dateEnd) {
      MessageServices.ShowWarning(
        "A data inicial não pode ser maior que a final.",
      );
      return;
    }

    if (isNaN(dateStart.getTime()) && !isNaN(dateEnd.getTime())) {
      MessageServices.ShowWarning(
        "A data inicial deve ser informada quando a data final estiver preenchida.",
      );
      return;
    }

    if (!isNaN(dateStart.getTime()) && isNaN(dateEnd.getTime())) {
      MessageServices.ShowWarning(
        "A data final deve ser informada quando a data final estiver preenchida.",
      );
      return;
    }

    if (isNaN(dateStart.getTime()) || isNaN(dateEnd.getTime())) {
      MessageServices.ShowWarning(
        "data final e data inicial não pode ser vazio.",
      );
      return;
    }

    const result = [];
    let currentMonth = startMonth;
    let currentYear = startYear;

    while (
      currentYear < endYear ||
      (currentYear === endYear && currentMonth <= endMonth)
    ) {
      const competencia = `${String(currentMonth).padStart(
        2,
        "0",
      )}/${currentYear}`;

      result.push({
        ...ids_empresa["0"],
        competencia, // aqui atualiza a competência interna também
      });

      currentMonth++;
      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear++;
      }
    }

    if (result.length > 0) {
      setDadosMassivoRetro(result);
    }
  }
  return (
    <div className="cadastroagendamento row">
      <form
        onSubmit={handleSubmit(handleSalvarAgendamento)}
        className="row mb-4"
      >
        <div
          className="col-12 row"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="col-md-2 col-6">
            <Input
              dflex={false}
              placeholder="MM/YYYY"
              title="Competência"
              setValue={setValue}
              register={register}
              errors={errors}
              name={`competencia`}
              mask="mesAno"
              disabled={valueDropDownLst["spedretificadora"]?.id === 1}
              registerProps={{
                required:
                  valueDropDownLst["qualautomacao"]?.id === 1 &&
                  valueDropDownLst["spedretificadora"]?.id === 0
                    ? "Campo obrigatória"
                    : false,
                validate: {
                  sValid: (value) =>
                    UtilServices.validateMonthYear(value) || "Data inválida.",
                },
              }}
            />
          </div>
          <div className="col-md-6 col-12 mt-md-0 mt-2">
            <DropDownList
              title="Filtrar Empresa"
              setValue={setValue}
              register={register}
              errors={errors}
              name="empresa"
              value={valueDropDownLst["empresa"]}
              onChange={handleChangeDropDownLst}
              data={dadosLstEmpresa}
              loading={isPendingD}
            />
          </div>
          <div className="col-md-2 col-6">
            <ButtonIcon
              Clear
              className="clear-icon"
              titleClear="Limpar os filtros"
              typeClear="button"
              onClear={() => {
                startTransition(() => {
                  handleClear();
                });
              }}
            />
          </div>
        </div>
        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Qual Automação ?"
            setValue={setValue}
            register={register}
            errors={errors}
            name="qualautomacao"
            value={valueDropDownLst["qualautomacao"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 1, key: "EFD Contribuição" },
              { id: 2, key: "Receita BX" },
            ]}
            disabled
          />
        </div>
        {valueDropDownLst["qualautomacao"]?.id === 2 && (
          <>
            <div className="col-md-2 col-6 mt-2">
              <Input
                dflex={false}
                placeholder="MM/YYYY"
                title="Mês Inicial"
                setValue={setValue}
                register={register}
                errors={errors}
                name={`mesinicial`}
                mask="mesAno"
                registerProps={{
                  required: "Campo obrigatório",
                  validate: {
                    sValid: (value) =>
                      UtilServices.validateMonthYear(value) || "Data inválida.",
                  },
                }}
              />
            </div>
            <div className="col-md-2 col-6 mt-2">
              <Input
                dflex={false}
                placeholder="MM/YYYY"
                title="Mês Final"
                setValue={setValue}
                register={register}
                errors={errors}
                name={`mesfinal`}
                mask="mesAno"
                registerProps={{
                  required: "Campo obrigatório",
                  validate: {
                    sValid: (value) =>
                      UtilServices.validateMonthYear(value) || "Data inválida.",
                  },
                }}
              />
            </div>
          </>
        )}
        {valueDropDownLst["qualautomacao"]?.id === 1 && (
          <div className="col-md-4 col-12 mt-2">
            <DropDownList
              title="Pular a etapa do sistema dominio?"
              setValue={setValue}
              register={register}
              errors={errors}
              required
              name="pulardominio"
              value={valueDropDownLst["pulardominio"]}
              onChange={handleChangeDropDownLst}
              data={[
                { id: 0, key: "Sim" },
                { id: 1, key: "Não" },
              ]}
              registerProps={{
                required: "Campo obrigatório",
              }}
              tooltip
              tooltipDescricao="<p>
                                  Caso o <strong>EFD Contribuições</strong> já tenha sido <strong>gerado automaticamente</strong> pelo domínio em nosso sistema, você pode <strong>pular esta etapa</strong>.
                                </p>"
              tooltipId="tooltip-001"
              tooltipIconColor="#FFDF5E"
              tooltipIcon={<i class="fa-regular fa-question"></i>}
            />
          </div>
        )}
        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Tipo de Agendamento"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="tipoagendamento"
            value={valueDropDownLst["tipoagendamento"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 1, key: "Manual (Somente desta vez)" },
              { id: 2, key: "Mensal" },
            ]}
            registerProps={{
              required: "Campo obrigatório",
            }}
            tooltip
            tooltipDescricao="
            <p>Para <strong>agendamentos manuais</strong> com a <strong>opção 'Deseja replicar para os proximos meses ?'</strong>, <br/> o sistema buscará automaticamente os <strong>arquivos correspondentes ao mês de competência</strong>.</p>
            <p>Para empresas cuja automação não está vinculada ao sistema domínio, é necessário atualizar o arquivo mensalmente.</p>"
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
        {valueDropDownLst["tipoagendamento"]?.key ===
          "Manual (Somente desta vez)" && (
          <>
            <div className="col-md-6 col-12 row">
              <div className="col-md-4 col-12 mt-2">
                <Input
                  dflex={false}
                  placeholder="DD/MM/YYYY"
                  title="Data"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  name={`data`}
                  mask="Date"
                  registerProps={{
                    required: "Data obrigatório",
                    validate: {
                      sValid: (value) =>
                        UtilServices.validateDate(value) || "Data inválido.",
                    },
                  }}
                />
              </div>
              <div className="col-md-3 col-12 mt-2">
                <Input
                  dflex={false}
                  placeholder="00:00"
                  title="Hora"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  name={`hora`}
                  mask="Horario"
                  registerProps={{
                    required: "Hora obrigatório",
                    validate: {
                      sValid: (value) =>
                        UtilServices.validateHorario(value) ||
                        "Horário inválido.",
                    },
                  }}
                />
              </div>
              <CheckBox
                checked={check}
                className="col-md-9 col-12 mt-2"
                onChange={(e) => setCheck(e.target.checked)}
                title="Deseja replicar para os proximos meses ?"
              />
            </div>
          </>
        )}
        {valueDropDownLst["tipoagendamento"]?.key === "Mensal" && (
          <div className="col-md-3 col-12 mt-2">
            <DropDownList
              title="Tipo"
              setValue={setValue}
              register={register}
              errors={errors}
              required
              name="tipomensal"
              value={valueDropDownLst["tipomensal"]}
              onChange={handleChangeDropDownLst}
              data={[
                { id: 1, key: "Todo dia 1" },
                { id: 2, key: "Todo final do mês" },
              ]}
              registerProps={{
                required: "Campo obrigatório",
              }}
            />
          </div>
        )}
        {/* RETROATIVOS */}
        <div className="col-12 icon-default mt-5">
          <i class="fa-solid fa-rotate-right"></i>
          <p>Retroativos</p>
        </div>
        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="*Existem sped para retificar ?"
            placeholder="Selecione Sim ou Não"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="spedretificadora"
            value={valueDropDownLst["spedretificadora"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 1, key: "Sim" },
              { id: 0, key: "Não" },
            ]}
            registerProps={{
              required: "Campo obrigatório",
            }}
            tooltip
            tooltipDescricao="Informe se o SPED é uma retificação caso <strong>'Sim'</strong>, inclua o número do recibo."
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
        {valueDropDownLst["spedretificadora"]?.key === "Sim" && (
          <>
            <div className="col-md-2 col-5 mt-2">
              <Input
                dflex={false}
                title="De"
                placeholder="MM/YYYY"
                setValue={setValue}
                register={register}
                errors={errors}
                name={"decompetencia"}
                mask="mesAno"
                registerProps={{
                  validate: {
                    sValid: (value) => {
                      if (!UtilServices.validateMonthYear(value)) {
                        return "Competência inválida.";
                      }

                      const [mes, ano] = value.split("/").map(Number);
                      if (!mes || !ano) return "Competência inválida.";

                      const hoje = new Date();
                      const anoAtual = hoje.getFullYear();
                      const mesAtual = hoje.getMonth() + 1; // Janeiro = 0, por isso +1

                      // Calcula o mês/ano mínimo permitido (mês atual - 1)
                      let mesMin = mesAtual - 1;
                      let anoMin = anoAtual;
                      if (mesMin === 0) {
                        mesMin = 12;
                        anoMin = anoAtual - 1;
                      }

                      // Se for maior ou igual ao mês atual - 1 => inválido
                      if (ano > anoMin || (ano === anoMin && mes >= mesMin)) {
                        return "Competência não pode ser do mês atual ou futuro.";
                      }

                      return true;
                    },
                  },
                }}
                tooltip
                tooltipDescricao="Para retroativos você pode incluir mais de um mês"
                tooltipId="tooltip-001"
                tooltipIconColor="#FFDF5E"
                tooltipIcon={<i class="fa-regular fa-question"></i>}
              />
            </div>
            <div className="col-md-2 col-5 mt-2">
              <Input
                title="Até"
                placeholder="MM/YYYY"
                setValue={setValue}
                register={register}
                errors={errors}
                name={"atecompetencia"}
                mask="mesAno"
                registerProps={{
                  validate: {
                    sValid: (value) => {
                      if (!UtilServices.validateMonthYear(value)) {
                        return "Competência inválida.";
                      }

                      const [mes, ano] = value.split("/").map(Number);
                      if (!mes || !ano) return "Competência inválida.";

                      const hoje = new Date();
                      const anoAtual = hoje.getFullYear();
                      const mesAtual = hoje.getMonth() + 1; // Janeiro = 0, por isso +1

                      // Calcula o mês/ano mínimo permitido (mês atual - 1)
                      let mesMin = mesAtual - 1;
                      let anoMin = anoAtual;
                      if (mesMin === 0) {
                        mesMin = 12;
                        anoMin = anoAtual - 1;
                      }

                      // Se for maior ou igual ao mês atual - 1 => inválido
                      if (ano > anoMin || (ano === anoMin && mes >= mesMin)) {
                        return "Competência não pode ser do mês atual ou futuro.";
                      }

                      return true;
                    },
                  },
                }}
                dflex
                button
                iconButton="Refresh"
                titleButton="Calcular os meses para registrar os recibos"
                typeButton="button"
                onClickButton={() => {
                  handleGenerateCompetencias();
                }}
                gapButton="10px"
                disabledButton={false}
              />
            </div>
          </>
        )}
        <div className="col-12 mb-5 row">
          {valueDropDownLst["spedretificadora"]?.key === "Sim" &&
            dadosMassivoRetro.length > 0 &&
            dadosMassivoRetro.map((item, index) => (
              <div className="mt-md-2 mt-4 row">
                <div className="col-md-3 col-6 mt-2">
                  <Input
                    dflex={false}
                    title="Empresa"
                    value={item?.["Razão Social"]}
                    maxLength="5"
                    type="document"
                    disabled
                  />
                </div>
                <div className="col-md-3 col-6 mt-2">
                  <Input
                    dflex={false}
                    title="Competência"
                    value={item?.competencia}
                    maxLength="5"
                    type="document"
                    disabled
                  />
                </div>
                <div className="col-md-3 col-12 mt-2">
                  <Input
                    dflex={false}
                    title="Número do Recibo"
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    name={`idrecibo_${item?.id_empresa}_${item?.competencia}`}
                    mask="CaracteresEspeciais"
                    registerProps={{
                      required:
                        valueDropDownLst[
                          `retificacao_${item?.id_empresa}_${item?.competencia}`
                        ]?.key !== "Sim"
                          ? false
                          : "Campo obrigatório",
                      validate: {
                        sValid: (value) =>
                          value?.length > 39 || "Recibo inválido.",
                      },
                    }}
                  />
                </div>
              </div>
            ))}
        </div>

        <div className="mt-5">
          <Grid
            dadosGrid={dadosEmpresa}
            columns={mappingColumn.getRPA_EmpresasAgendadores(dadosEmpresa)}
            {...(dadosEmpresa?.length > 0 && {
              pageVisible: true,
            })}
            selection={{
              allowSelectAll: true,
              mode: "multiple",
              showCheckBoxesMode: "always",
            }}
            iconTitle="<i class='fa-solid fa-users'></i>"
            title="Quais empresas deseja agendar? "
            Memo={false}
            useLoading={isPendingB}
            pagingStaticSize="5"
            onSelectionChanged={(e) => {
              setIdsEmpresa(e.selectedRowKeys);
            }}
          />
        </div>
        <Button
          nome="Agendar"
          icon="<i class='fa-solid fa-plus'></i>"
          theme="2"
        />
      </form>
    </div>
  );
};

export default CadastroAgendamento;
